import { makeAutoObservable } from 'mobx';

import { StockistIssue } from "../DTOs/StockistIssue";
import { ajaxController } from "./AjaxController";
import { PromotionSummary } from "../DTOs/PromotionSummary";

export class IssueAjaxController {
  private _ajaxController = ajaxController;
  private _issueEndpoint = "stockistIssue"
  private _indieMagazinesCategory = 700

  getIndieMagazinesPaged(offset: number = 0, total: number = 50) {
    return this._ajaxController.get<StockistIssue[]>(
      `${this._issueEndpoint}/latest/${this._indieMagazinesCategory}/${offset}/${total}`,
      {},
      StockistIssue
    )
  }

  getUpcomingIssues() {
    return this._ajaxController.get<StockistIssue[]>(
      `${this._issueEndpoint}/upcoming/${this._indieMagazinesCategory}`,
      {},
      StockistIssue
    )
  }

  searchUpcomingIssues(searchText: string) {
    return this._ajaxController.get<StockistIssue[]>(
      `${this._issueEndpoint}/search/upcoming/${this._indieMagazinesCategory}`,
      {
        SearchText: searchText
      },
      StockistIssue
    )
  }

  getAllIssuesForMagazine(magazineId: number) {
    return this._ajaxController.getNoCast<StockistIssue[]>(
      `${this._issueEndpoint}/allIssues/${magazineId}`,
      {}
    )
  }

  search(searchText: string, pageNumber: number = 0, pageSize: number = 50) {
    return this._ajaxController.get<StockistIssue[]>(
      `${this._issueEndpoint}/search/full`,
      {
        SearchText: searchText,
        PageNumber: pageNumber,
        PageSize: pageSize
      },
      StockistIssue
    )
  }

  getIssueById(id: number) {
    return this._ajaxController.get<StockistIssue>(
      `${this._issueEndpoint}/${id}`,
      {},
      StockistIssue
    );
  }

  getCurrentIssueIdByMagazineSlug(magazineSlug: string) {
    return this._ajaxController.getNoCast<number>(
      `${this._issueEndpoint}/current-issue-id/${magazineSlug}`,
      {}
    );
  }

  getIssuesForExtras() {
    return this._ajaxController.get<StockistIssue[]>(
      `${this._issueEndpoint}/extras`,
      {},
      StockistIssue
    );
  }

  searchIssuesForExtras(searchText: string) {
    return this._ajaxController.get<StockistIssue[]>(
      `${this._issueEndpoint}/search/extras`,
      { searchText },
      StockistIssue
    );
  }

  getPromotionSummary(issueId: number) {
    return this._ajaxController.get<PromotionSummary>(
      `${this._issueEndpoint}/promotion-summary/${issueId}`,
      {},
      PromotionSummary
    );
  }

  getPublisherFreebieEligibility(publisherId: number) {
    return this._ajaxController.getNoCast<boolean>(
      `${this._issueEndpoint}/publisher-freebie-eligible/${publisherId}`,
      {}
    );
  }

  constructor() {
    makeAutoObservable(this);
  }
}

export const issueAjaxController = new IssueAjaxController();